var _path, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.38462C0 3.3062 3.3062 0 7.38462 0C11.463 0 14.7692 3.3062 14.7692 7.38462C14.7692 10.8521 13.0859 12.2086 11.5165 13.4733C10.4873 14.3026 9.50718 15.0925 9.08308 16.4123L8.61231 17.8338C8.48031 18.2265 8.10291 18.4831 7.68923 18.4615H7.17231C6.75863 18.4831 6.38123 18.2265 6.24923 17.8338L5.77846 16.4123C5.33738 15.0964 4.34351 14.3073 3.30224 13.4806C1.70676 12.2139 0 10.8588 0 7.38462ZM4.61538 7.38462C4.61538 8.91402 5.85521 10.1538 7.38461 10.1538C8.11906 10.1538 8.82343 9.86209 9.34276 9.34276C9.86209 8.82343 10.1538 8.11906 10.1538 7.38462C10.1538 5.85521 8.91402 4.61538 7.38461 4.61538C5.85521 4.61538 4.61538 5.85521 4.61538 7.38462Z",
    fill: "#4001C5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.38462,
    cy: 22.309,
    rx: 1.84615,
    ry: 1.84615,
    fill: "#4001C5"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Pin.2d0051d8.svg";
export { ForwardRef as ReactComponent };